module.exports = __webpack_public_path__ + "static/media/R&R_-set-3.86abbece.jpg";